import $ from 'jquery'

import { MOBILE_CLASS } from '../constants/header'

import NavigationDesktop from './header/NavigationDesktop'
import NavigationMobile from './header/NavigationMobile'

class Navigation {
  constructor(selector = '.main-nav') {
    this.navs = $(selector)

    this.init()
  }

  init() {
    this.navs.each((index, el) => {
      const nav = $(el)

      if (nav.hasClass(MOBILE_CLASS)) {
        return new NavigationMobile(nav)
      }

      return new NavigationDesktop(nav)
    })
  }
}

export default Navigation
